import type { BytemdSafeMdxViewerPlugin } from '@tarslib/bytemd-processor';
import type { Root } from 'mdast';
import { visit } from 'unist-util-visit';

function addQueryParam(url: string, key: string, value: string) {
  const urlObject = new URL(url);

  const queryParams = new URLSearchParams(urlObject.search);

  queryParams.set(key, value);

  urlObject.search = queryParams.toString();

  return urlObject.href;
}

const QueryMap = {
  ['APIDOC']: 'apidoc',
  ['SHARE_DOC']: 'shareDoc',
} as const;

export const handleImageSrcAddParams = ({
  searchHostnames,
  onlineType,
  locale,
}: {
  searchHostnames: string[];
  // 组件层面的或类型用字符串字面量
  onlineType: 'SHARE_DOC' | 'APIDOC'; // relate explorer OnlineType
  locale: string;
}) => {
  return (raw: string) => {
    try {
      const URLObj = new URL(raw);
      const imageSrcHostname = URLObj.hostname;
      if (searchHostnames.includes(imageSrcHostname)) {
        let url = raw;
        url = addQueryParam(url, 'onlineShareType', QueryMap[onlineType]);
        url = addQueryParam(url, 'locale', locale);
        return url;
      }
      return raw;
    } catch (e) {}
    return raw;
  };
};

export default function pluginImageSrcAddParams(options: {
  searchHostnames: string[];
  // 组件层面的或类型用字符串字面量
  onlineType: 'SHARE_DOC' | 'APIDOC'; // relate explorer OnlineType
  locale: string;
}): BytemdSafeMdxViewerPlugin {
  const handler = handleImageSrcAddParams(options);
  return {
    remark: (process) => {
      return process.use(() => {
        return (tree: Root) => {
          visit(tree, 'image', (node: any) => {
            try {
              // eslint-disable-next-line no-param-reassign
              node.url = handler(node.url);
            } catch (error) {}
          });
        };
      });
    },
  };
}
